// Chart and bar legend: 8 px colour swatches with labels and optional values, wrapping in a 12 px muted row.
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export interface LegendItem {
  key: string;
  label: ReactNode;
  color: string;
  value?: ReactNode;
}

export function Legend({ items, className }: { items: readonly LegendItem[]; className?: string }) {
  return (
    <ul className={cn("m-0 flex list-none flex-wrap gap-3 p-0 text-xs text-muted-foreground", className)}>
      {items.map((item) => (
        <li key={item.key} className="inline-flex items-center gap-1.5">
          <i aria-hidden className="inline-block size-2 rounded-[2px]" style={{ background: item.color }} />
          {item.value === undefined ? null : (
            <b className="font-semibold text-foreground tabular-nums">{item.value}</b>
          )}
          {item.label}
        </li>
      ))}
    </ul>
  );
}
